module.exports = __webpack_public_path__ + "static/media/remove-user.4718918b.png";